import Cookies from 'js-cookie'
import fromUnixTime from 'date-fns/fromUnixTime'
import differenceInDays from 'date-fns/differenceInDays'

Cookies.defaults = { sameSite: 'Lax' }

export const SESSION_COOKIE = 'mk_session_info'

export const getHeaderExpiry = response => fromUnixTime(response.headers.expiry)

export const setAuthCredentials = response => {
  const expiryDate = getHeaderExpiry(response)
  Cookies.set(SESSION_COOKIE, JSON.stringify(response.headers), {
    expires: differenceInDays(expiryDate, new Date()),
  })
}

export const getAuthData = () => {
  const savedAuthInfo = Cookies.get(SESSION_COOKIE)
  if (!savedAuthInfo) return null
  try {
    return JSON.parse(savedAuthInfo)
  } catch (e) {
    return null
  }
}

export const hasAuthCookie = () => Boolean(Cookies.get(SESSION_COOKIE))

export const clearAuthCookies = () => {
  Cookies.remove(SESSION_COOKIE)
}
